import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { UserEntity } from 'app/interfaces/entity';
import { createBrowserHistory } from 'history';

import { Environment } from 'app/enums';
import environmentConfig from 'config/config';

const history = createBrowserHistory();

export const initSentry = (): void => {
  if (environmentConfig.frontendEnvironment === Environment.Local) {
    return;
  }

  Sentry.init({
    dsn: environmentConfig.sentryDns,
    autoSessionTracking: false,
    integrations: [
      new Integrations.BrowserTracing({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
      }),
    ],
    ignoreErrors: ['ResizeObserver loop completed with undelivered notifications.'],
    environment: environmentConfig.frontendEnvironment,
  });
};

export const setUser = (user: UserEntity | null): void => {
  if (environmentConfig.frontendEnvironment === Environment.Local) {
    return;
  }

  if (!user) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.userName,
  });
};
